export const state = {
  userInfo: {},
  companyInfo: {},
};
